import { NexusAgent } from '../../domain/agents/models/Agent';
import { ChatProviderType } from '../../domain/chat/models/ChatProviderType';

export const isNexusAgent = (value: unknown): value is NexusAgent => {
    return (
        typeof value === 'object' &&
        value !== null &&
        'providerType' in value &&
        (value as { providerType?: ChatProviderType }).providerType === ChatProviderType.Nexus
    );
};
